import { createSelector } from 'reselect';

import { selectSubCompany } from './subCompany.selectors';

const selectSubCompanySignupConfigState = createSelector(
  selectSubCompany,
  subCompany => subCompany?.signupConfig || {},
);

// { tpoSignupConfigurationId, name, createdDate } or null.
export const selectSubCompanySignupConfig = createSelector(
  selectSubCompanySignupConfigState,
  state => state.config || null,
);
